import classes from './LineSeparator.module.css'

const LineSeparator = () => {
    return (
        <div className={classes.line}></div>
    )
}

export default LineSeparator;